import ReviewApprovalValues from '../../../variables/reviewApprovalValues';

export default {
  /**
   * @param state
   * @returns {Array}
   */
  availableDomains: (state) => {
    let brands = state.filter.selectedBrands;
    if (!brands.length) {
      brands = state.filter.items;
    }
    let domains = [];
    for (let i = 0; i < brands.length; i += 1) {
      domains = [...domains, ...brands[i].domains];
    }
    return domains;
  },

  /**
   * @param state
   * @returns {boolean}
   */
  disabledSelectAll: (state) => {
    const reviews = state.approval.items.reviews || [];
    const noReviews = reviews.length === 0;
    const selectedReviews = state.bulk.reviewIds || [];
    const allReviewsSelected = reviews.length === selectedReviews.length;
    return noReviews || allReviewsSelected;
  },

  /**
   * @param state
   * @returns {boolean}
   */
  disabledDeselectAll: (state) => {
    const selectedReviews = state.bulk.reviewIds || [];
    return selectedReviews.length === 0;
  },

  /**
   * @param state
   * @returns {boolean}
   */
  disabledApproveSelected: (state) => {
    const approvalStatusFilter = state.overview.approvalStatusFilter;
    return approvalStatusFilter === ReviewApprovalValues.APPROVED;
  },

  /**
   * @param state
   * @returns {boolean}
   */
  disabledDisapproveSelected: (state) => {
    const approvalStatusFilter = state.overview.approvalStatusFilter;
    return approvalStatusFilter === ReviewApprovalValues.DISAPPROVED;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/review/getters.js